module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//gorilla_6_3.png?v=764b0600";